module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "ebook-toc",
    attrs: {
      "id": "_idParaDest-2"
    }
  }, [_c('span', {
    staticClass: "ch-opener CharOverride-3"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor001"
    }
  }), _vm._v("contents")])]), _vm._v(" "), _c('div', {
    staticClass: "l1"
  }, [_c('p', {
    staticClass: "Normal th"
  }, [_c('a', {
    attrs: {
      "href": "#/SparksPhoenix_epub4#_idParaDest-4"
    }
  }, [_c('span', {
    staticClass: "ch-opener CharOverride-4"
  }), _c('span', {
    staticClass: "ch-opener CharOverride-5"
  }, [_vm._v("I      the burning")])])]), _vm._v(" "), _c('p', {
    staticClass: "Normal th"
  }, [_c('span', {
    attrs: {
      "href": "#/SparksPhoenix_epub5#_idParaDest-5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ch-opener CharOverride-5"
  }, [_vm._v("II     turning to ashes")])])]), _vm._v(" "), _c('p', {
    staticClass: "Normal th"
  }, [_c('span', {
    attrs: {
      "href": "#/SparksPhoenix_epub6#_idParaDest-6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ch-opener CharOverride-5"
  }, [_vm._v("III    sparks of phoenix")])])]), _vm._v(" "), _c('p', {
    staticClass: "Normal th"
  }, [_c('span', {
    attrs: {
      "href": "#/SparksPhoenix_epub7#_idParaDest-7",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ch-opener CharOverride-5"
  }, [_vm._v("IV    the rising")])])]), _vm._v(" "), _c('p', {
    staticClass: "Normal th"
  }, [_c('span', {
    attrs: {
      "href": "#/SparksPhoenix_epub8#_idParaDest-8",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ch-opener CharOverride-5"
  }, [_vm._v("V      the soaring")])])]), _vm._v(" "), _c('p', {
    staticClass: "Normal th"
  }, [_c('span', {
    attrs: {
      "href": "#/SparksPhoenix_epub9#_idParaDest-9",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ch-opener CharOverride-5"
  }, [_vm._v("VI    a new chapter")])])])]), _vm._v(" "), _c('div', {
    staticClass: "l2"
  }, [_c('p', {
    staticClass: "Normal t1 ParaOverride-2"
  }, [_c('span', {
    attrs: {
      "href": "#/SparksPhoenix_epub10#_idParaDest-10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ch-opener CharOverride-4"
  }, [_vm._v("\t\tan invitation")])])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    attrs: {
      "href": "#/SparksPhoenix_epub11#_idParaDest-11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ch-opener CharOverride-4"
  }, [_vm._v("\t\tacknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "Normal"
  }, [_c('span', {
    attrs: {
      "href": "#/SparksPhoenix_epub12#_idParaDest-12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "ch-opener CharOverride-4"
  }, [_vm._v("\t\tabout the author")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a948052","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SparksPhoenix_epub2.vue
// module id = 63
// module chunks = 0